var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"meter-online-fault-chart"},[_c('div',{staticClass:"chart-header"},[_c('h3',{staticClass:"chart-title"},[_vm._v(_vm._s(_vm.$t('水表在线率/故障率')))])]),_c('div',{staticClass:"chart-container"},[_c('div',{ref:"chart",staticStyle:{"height":"100%","width":"100%"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }